import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { set } from '../../../store/Opportunity/ProjectUses';

function ProjectUses() {
  const dispatch = useDispatch();
  const projectUsesState = useSelector((state: RootState) => state.opportunity.projectUses);

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Project Uses</h2>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Acquisition</label>
        <input
          type='number'
          name='acquisition'
          value={projectUsesState.acquisition === 0 ? '' : projectUsesState.acquisition}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Construction Cost</label>
        <input
          type='number'
          name='constructionCost'
          value={projectUsesState.constructionCost === 0 ? '' : projectUsesState.constructionCost}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Soft Cost</label>
        <input
          type='number'
          name='softCost'
          value={projectUsesState.softCost === 0 ? '' : projectUsesState.softCost}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Finance Cost</label>
        <input
          type='number'
          name='financeCost'
          value={projectUsesState.financeCost === 0 ? '' : projectUsesState.financeCost}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Development Cost</label>
        <input
          type='number'
          name='developmentCost'
          value={projectUsesState.developmentCost === 0 ? '' : projectUsesState.developmentCost}
          className='form-input'
          onChange={changeHandler}
        />
      </div>
    </>
  );
}

export default ProjectUses;
